import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames/bind';
import { selectIsMobilePDPImageZoomed } from 'yoda-site-components/lib/selectors/ContextSelector';
import Icon from 'yoda-core-components/lib/components/Icon/Icon';
import * as styles from './UrgencyMessaging.css';

const cx = classNames.bind(styles);

export class UrgencyMessageBlock extends Component {
    static defaultProps = {
        urgencyMessage: {},
        delay: null,
        animationDelay: null,
        shouldAnimate: false,
    };

    static propTypes = {
        deviceType: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
        urgencyMessage: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        delay: PropTypes.number,
        animationDelay: PropTypes.number,
        shouldAnimate: PropTypes.bool,
        isMobilePDPImageZoomed: PropTypes.bool.isRequired,
        enableZoomOnProductImage: PropTypes.bool.isRequired,
    };

    constructor(props) {
        super(props);
        this.state = {
            expanded: false,
            componentShown: false,
            messageShown: false,
        };

        this.showComponent = this.showComponent.bind(this);
    }

    componentDidMount() {
        const { isMobilePDPImageZoomed, enableZoomOnProductImage } = this.props;
        if (!enableZoomOnProductImage) this.showComponent(true);
        else if (!isMobilePDPImageZoomed) this.showComponent(true);
    }

    componentDidUpdate(prevProps, prevState) {
        const { isMobilePDPImageZoomed, enableZoomOnProductImage } = this.props;
        const { componentShown, messageShown } = prevState;
        /* istanbul ignore next */
        if (
            enableZoomOnProductImage &&
            isMobilePDPImageZoomed !== prevProps.isMobilePDPImageZoomed
        ) {
            if (!isMobilePDPImageZoomed && !componentShown && !messageShown) {
                this.showComponent(true);
                this.handleMessageShown();
            } else if (isMobilePDPImageZoomed) {
                if (componentShown) {
                    this.handleMessageShown(true);
                } else {
                    this.handleMessageShown(false);
                }
                !componentShown && this.showComponent(false);
            }
        }
    }

    /* istanbul ignore next */
    handleMessageShown(isMessageShown = true) {
        this.setState({ messageShown: isMessageShown });
    }

    /* istanbul ignore next */
    showComponent(isshowcomponent = true) {
        const { enableZoomOnProductImage, isMobilePDPImageZoomed } = this.props;
        const { componentShown } = this.state;
        // when zoom in we should not show
        let isUpdatedShowState = isshowcomponent;
        if (!enableZoomOnProductImage) {
            isUpdatedShowState = true;
        } else if (isMobilePDPImageZoomed && !componentShown) {
            isUpdatedShowState = false;
        }
        setTimeout(() => {
            this.setState({ componentShown: isUpdatedShowState });
        }, this.props.delay);
    }

    addAnimationOnLoad() {
        /* istanbul ignore next */
        setTimeout(() => {
            this.setState({ expanded: true });
        }, this.props.delay + 2000);
        /* istanbul ignore next */
        setTimeout(() => {
            this.setState({ expanded: false });
        }, this.props.animationDelay + 8000);
    }

    addAnimation() {
        this.setState({ expanded: true });
        /* istanbul ignore next */
        setTimeout(() => {
            this.setState({ expanded: false });
        }, 3000);
    }

    render() {
        const { urgencyMessage, deviceType, shouldAnimate } = this.props;
        let iconDimension = '';
        let iconViewBoxMobileTablet = '';
        const styleExpanded = null;
        const styleOnMouseOver = null;
        let styleUrgencyMsg = null;
        let styleUrgencyMsgTxt = null;
        let iconContainer = null;
        let styleUrgencyAnimation = null;
        iconDimension = deviceType.isDesktop ? '24px' : '20px';
        iconViewBoxMobileTablet =
            urgencyMessage.iconName === 'urgency-pdp-view' ? '0 1 24 24' : '0 2 24 24';
        styleUrgencyMsg = 'urgencyMsgBottom';
        styleUrgencyMsgTxt = 'urgencyMsgBottomTxt';
        styleUrgencyAnimation = shouldAnimate ? 'animate' : 'inanimate';
        iconContainer = (
            <span
                data-automation-id="urgencyMsgIcon"
                className={cx('urgencyMsgIcon', 'urgencyIcon')}
            >
                <Icon
                    iconType="svg"
                    pathClassName={cx('iconPath')}
                    className={cx('svg-icon')}
                    width={iconDimension}
                    height={iconDimension}
                    viewBox={deviceType.isDesktop ? '0 -1 24 24' : iconViewBoxMobileTablet}
                >
                    {urgencyMessage.iconComponent}
                </Icon>
            </span>
        );
        const { componentShown, messageShown } = this.state;

        return componentShown && !messageShown ? (
            <div
                className={cx('urgencyMsg', styleExpanded, styleUrgencyAnimation, styleUrgencyMsg)}
                onMouseOver={styleOnMouseOver}
            >
                {iconContainer}
                <span
                    data-automation-id="urgencyMsgContent"
                    className={cx('urgencyMsgText', styleUrgencyMsgTxt)}
                >
                    {' '}
                    {urgencyMessage.message}{' '}
                </span>
            </div>
        ) : null;
    }
}

const mapStateToProps = (state) => ({
    isMobilePDPImageZoomed: selectIsMobilePDPImageZoomed(state),
});

export default connect(mapStateToProps, null)(UrgencyMessageBlock);
